var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 70,
    height: 70,
    rx: 35,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7328 32.9322C50.4641 33.2369 50.8906 33.9682 50.9516 34.6994C50.9516 35.4916 50.4641 36.2229 49.7328 36.5275L22.4328 48.2275C22.1891 48.3494 21.9453 48.4104 21.7016 48.4104C21.1531 48.4104 20.6047 48.1666 20.2391 47.74C19.6906 47.1916 19.5687 46.2775 19.9344 45.5463L25.6016 34.6994L19.9344 23.9135C19.5687 23.1822 19.6906 22.2682 20.2391 21.6588C20.6047 21.2322 21.1531 21.0494 21.7016 21.0494C21.9453 21.0494 22.1891 21.1104 22.4328 21.2322L49.7328 32.9322ZM23.7734 25.0104L28.1 33.2369H43.0906L23.7734 25.0104ZM28.1 36.1619L23.7734 44.4494L43.0906 36.1619H28.1Z",
    fill: "#fff",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitCircleIcon);
export default __webpack_public_path__ + "static/media/submitCircleIcon.31408d1080184baf715668c29bd2cf4b.svg";
export { ForwardRef as ReactComponent };